class VariantChange  extends HTMLElement {
    constructor() {
        super();
        const _this = this;
        this.radioButons = this.querySelectorAll('input[type="radio"]')
        if(this.radioButons){
            this.radioButons.forEach(function (input){
                input.addEventListener('change', _this.ChangeVariant.bind(_this));
            })
        }

    }
    ChangeVariant(){
        this.GetOptions();
        this.GetVariantId();
        this.UpdateUrl();
        this.UpdateContent().then(() => {
           this.UpdateButton();
        });

    }


    GetOptions() {
        /* options change*/
        const fieldsets = Array.from(this.querySelectorAll('[data-product-options-group]'));
        this.options = fieldsets.map((fieldset) => {
            return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
        });
    }
    GetVariantId(){
        const variantJson = JSON.parse(this.querySelector('[type="application/json"]').textContent)
        /* options change*/
        this.currentVariant = variantJson.find((variant) => {
            return !variant.options.map((option, index) => {
                return this.options[index] === option;
            }).includes(false);
        });
    }
    UpdateUrl(){
        if (!this.currentVariant) return;
        window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    UpdateButton(){
        fetch('/cart.js')
            .then(response => response.json())
            .then(cartData => {
                let targetProductId = this.currentVariant.id;
                let isProductInCart = cartData.items.some(item => item.variant_id == targetProductId);
                const buttonAdd = document.querySelector('[data-product-button]');

                if (isProductInCart) {
                    if (!buttonAdd.classList.contains("product-in-cart")) {
                        buttonAdd.classList.add("product-in-cart");
                    }
                } else {
                    if (buttonAdd.classList.contains("product-in-cart")) {
                        buttonAdd.classList.remove("product-in-cart");
                    }
                }
            })
            .catch(error => console.error('Помилка отримання даних корзини:', error));
    }

    UpdateContent(){
        return new Promise((resolve, reject) => {
        this.closest('product-form').querySelector('form').querySelector('input[name="id"]').value =this.currentVariant.id;
        // document.querySelector('.product-page-wrapper product-form').querySelector('button[name="add"]').classList.add('loading');
        fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
            .then((response) => {
                return response.text();
            })

            .then((response_html) => {
                const html = new DOMParser().parseFromString(response_html, 'text/html');
                const fetchPrice = html.querySelector('[data-product-price]');
                const fetchProductHeader = html.querySelector('[cart-box__header]');
                const fetchButton = html.querySelector('[data-product-button]')
                const fetchError = html.querySelector('.product-error');
                const price = document.querySelector('[data-product-price]');
                const button = document.querySelector('[data-product-button]');
                const productHeader = document.querySelector('[cart-box__header]');
                const error = document.querySelector('.product-error');
                var windowWidth = $(window).innerWidth();
                let $block = $('.page-layout');
                let  $cartBoxQuantity = $block.find('.cart-box__quantity');
                let  $cartBoxButtons = $block.find('.cart-box__buttons');
                let  $cartBoxSectionAside = $block.find('.cart-box__section-aside');
                let  PHONE_TABLET = 1024;
                function changeCartButtonsPosition() {
                    let windowWidth = $(window).innerWidth();
                    if (windowWidth < PHONE_TABLET) {
                        $cartBoxButtons.prepend($cartBoxQuantity);
                    } else {
                        $cartBoxSectionAside.prepend($cartBoxQuantity);
                    }
                }
                changeCartButtonsPosition()
                if(fetchButton && button){
                    button.innerHTML = fetchButton.innerHTML
                }
                if(fetchPrice && price){
                    price.innerHTML = fetchPrice.innerHTML
                }

                if(fetchProductHeader && productHeader){
                    productHeader.innerHTML = fetchProductHeader.innerHTML
                }
                if(fetchError && error){
                    error.innerHTML = fetchError.innerHTML
                }
                resolve();

            }) .catch((e) => {
            console.error(e);
            reject(e);
        });

        });
    }

}
customElements.define('variant-buttons', VariantChange )
